// extracted by mini-css-extract-plugin
module.exports = {"effect-collapse-fra":"EffectListCollapse_effect-collapse-fra__10BhV","see-all":"EffectListCollapse_see-all__zCL1z"};